import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";

import PageHead from "@/pages/Head";
import MobileMenu from "@/components/Header/MobileMenu";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import Cart from "@/components/Header/Offcanvas/Cart";
import EventBreadCrumb from "@/components/Events/EventBreadCrumb";
import EventDetails from "@/components/Events/EventDetails";
import CallToActionFour from "@/components/Call-To-Action/CallToAction-Four";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
// import { serialize } from 'next-mdx-remote/serialize'
// import { readFile } from 'fs/promises'
// import EventData from "../../../data/events.json";
import BackToTop from "@/pages/backToTop";
import CPStaticContent from '../../../models/CPStaticContent.js'
import CPEventRecaps from '../../../models/CPEventRecaps.js'
import Instagram from "@/components/Instagram/Instagram";
// import GoogleAdLarge from "@/components/Ads/GoogleAdLarge.js";

const SingleEvent = (event) => {
  const router = useRouter();
  const eventId = router.query.postId;
  const mdxSource = event.content
  const allEvents = event.list
  const getMatchEvent = event.info
  getMatchEvent['eventSimilar'] = event.similar

  useEffect(() => {
    if (eventId && getMatchEvent === undefined) {
      router.push("/events");
    }
  }, [getMatchEvent, router]);

  getMatchEvent.description['short'] = "Your Guide to " + getMatchEvent.parent.name + ": Exploring Upcoming and Past Events"

  return (
    <>
      <PageHead post={getMatchEvent} category="Event" />
      <Provider store={Store}>
        <Context>
          <MobileMenu />
          <HeaderStyleTen headerSticky="" headerType={true} />
          <Cart />

          <div className="rbt-breadcrumb-default rbt-breadcrumb-style-3">
            {getMatchEvent && <EventBreadCrumb getMatchEvent={getMatchEvent} />}
          </div>

          <div className="rbt-course-details-area rbt-section-gap">
            <div className="container">
              {getMatchEvent && <EventDetails getMatchEvent={getMatchEvent} eventContent={mdxSource} />}
            </div>
          </div>

          {/* <div className="rbt-callto-action rbt-cta-default style-4 bg-gradient-6 mt--75">
            <CallToActionFour btnClass="rbt-btn btn-gradient hover-icon-reverse" />
          </div> */}

          <Instagram />

          <BackToTop />
          <Separator />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default SingleEvent;

export async function getStaticProps(context) {
  const stContent = new CPStaticContent("events")
  await stContent.fetchContent()
  let event = await stContent.getItemProps(context.params.postId)
  // console.log(event)
  const parentId = event.props.info.parent.id
  // console.log(parentId)

  const eventRecaps = new CPEventRecaps(parentId)
  const eventRecapsList = await eventRecaps.fetchContent()
  // console.log(eventRecapsList)
  if (eventRecapsList) {
    event.props.info['past_events'] = eventRecapsList
  }
  return { props: event.props }
}

export async function getStaticPaths(context) {
  const stContent = new CPStaticContent("events")
  await stContent.fetchContent()
  const paths = await stContent.getPaths()
  return { paths, fallback: false }
}